import { DateTime, Duration, Info } from 'luxon'
import { z } from 'zod'

import SelectBase from '@/components/Form/Atoms/SelectBase/SelectBase'
import FormResolverUtils from '@/utils/FormResolverUtils'
import { InputKey } from '@/utils/inputKey'

const deliveryDates = (prefecture: string) => {
  const startDate = DateTime.local()
  const localeDate = startDate.setLocale('ja')
  const dateCandidates = Array.from({ length: 5 }, (_, i) => {
    let addDate =
      5 + (prefecture.includes('沖縄') || prefecture.includes('北海道') ? 1 : 0) + (localeDate.weekday === 6 ? 1 : 0)
    return localeDate.plus(Duration.fromObject({ days: i + addDate }))
  })

  return dateCandidates
}

export const deliveryDateDefaultValue = ({
  prefecture,
  deliveryDate,
}: {
  prefecture: string
  deliveryDate: string | null
}) => {
  const isoDates = deliveryDates(prefecture).map((deliveryDate) => deliveryDate.toISODate())
  return deliveryDate == null ? 'shortest' : isoDates.includes(deliveryDate) ? deliveryDate : 'shortest'
}

const formResolverUtils = FormResolverUtils({ schema: z.string(), i18nName: 'お届け日時の指定' })

export const deliveryDateInputKey = InputKey('deliveryDate', formResolverUtils.schema)

const DeliveryDateInput = ({ prefecture, label }: { prefecture: string; label: string | null }) => {
  const options = deliveryDates(prefecture).map((deliveryDate) => {
    return { label: generateLabel(deliveryDate), value: deliveryDate.toISODate()! }
  })

  return (
    <SelectBase
      label={label}
      name={deliveryDateInputKey.name}
      options={[{ label: '最短', value: 'shortest' }, ...options]}
    />
  )
}

export const generateLabel = (deliveryDate: DateTime) => {
  let dayOfWeek = Info.weekdays('short', { locale: 'ja' })[deliveryDate.weekday - 1]
  return `${deliveryDate.month}月${deliveryDate.day}日 (${dayOfWeek})`
}

export default DeliveryDateInput
